import { Link, useNavigate } from "react-router-dom";
import BRAND from "../components/brand";

export default function NavBar() {
  const role = localStorage.getItem("role");
  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <div style={styles.container}>
      
      {/* LEFT: BRAND */}
      <div style={styles.left}>
        <img src={BRAND.logo} alt="logo" style={styles.logo} />
        <div>
          <div style={styles.brandName}>{BRAND.name}</div>
          <div style={styles.role}>{role}</div>
        </div>
      </div>

      {/* CENTER: NAV LINKS */}
      <div style={styles.links}>
        {role === "CASHIER" && (
          <>
            <Link to="/punch" style={styles.link}>Punch</Link>
            <Link to="/cashier" style={styles.link}>Cashier</Link>
          </>
        )}

        {role === "CHEF" && (
          <Link to="/kds" style={styles.link}>KDS</Link>
        )}

        {role === "DISPATCH" && (
          <Link to="/dispatch" style={styles.link}>Dispatch</Link>
        )}

        {role === "MANAGER" && (
          <>
            <Link to="/kds" style={styles.link}>KDS</Link>
            <Link to="/dispatch" style={styles.link}>Dispatch</Link>
            <Link to="/day-end" style={styles.link}>Day End</Link>
            <Link to="/sales-report" style={styles.link}>Sales</Link>
          </>
        )}
      </div>

      {/* RIGHT: LOGOUT */}
      <button onClick={logout} style={styles.logout}>
        Logout
      </button>
    </div>
  );
}

const styles = {
  container: {
  height: 60,
  background: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 24px",
  borderBottom: "1px solid #e5e7eb"
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: 10
  },
  logo: {
    height: 40
  },
  brandName: {
  fontWeight: 600,
  fontSize: 16,
  color: "#111827"
  },
  role: {
  fontSize: 11,
  color: "#6b7280"
  },
  links: {
    display: "flex",
    gap: 20
  },
  link: {
  color: "#111827",
  textDecoration: "none",
  fontWeight: 500
  },
  logout: {
  background: "#2563eb",
  border: "none",
  color: "#fff",
  padding: "6px 14px",
  borderRadius: 8,
  cursor: "pointer"
  }
};